export const SET_CAMPAIGN_SEARCH = 'SET_CAMPAIGN_SEARCH'
export const SET_PACKAGE_FILTER = 'SET_PACKAGE_FILTER'
export const SET_COMPANY_SEARCH = 'SET_COMPANY_SEARCH'
export const SET_USER_TYPE_FILTER = 'SET_USER_TYPE_FILTER'
export const SET_MANAGE_PACKAGE_FILTER = 'SET_MANAGE_PACKAGE_FILTER'
export const SET_MANAGE_SEARCH = 'SET_MANAGE_SEARCH'
export const SET_MANAGE_BRANDS_SEARCH = 'SET_MANAGE_BRANDS_SEARCH'
export const SET_MANAGE_END_DATE = 'SET_MANAGE_END_DATE'
export const SET_MANAGE_START_DATE = 'SET_MANAGE_START_DATE'
export const SET_STATUS_FILTER = 'SET_STATUS_FILTER'
// active video actions
export const SET_ACTIVE_VIDEO_PLATFORM = 'SET_ACTIVE_VIDEO_PLATFORM'
export const SET_ACTIVE_VIDEO_PACKAGE = 'SET_ACTIVE_VIDEO_PACKAGE'
export const SET_ACTIVE_VIDEO_SEARCH = 'SET_ACTIVE_VIDEO_SEARCH'
export const SET_ACTIVE_VIDEO_TYPE = 'SET_ACTIVE_VIDEO_TYPE'
export const SET_ACTIVE_VIDEO_START_DATE = 'SET_ACTIVE_VIDEO_START_DATE'
export const SET_ACTIVE_VIDEO_END_DATE = 'SET_ACTIVE_VIDEO_END_DATE'

export const setCampaignSearch = payload => dispatch =>
  dispatch({
    type: SET_CAMPAIGN_SEARCH,
    payload: payload
  })

export const setPackageFilter = payload => dispatch =>
  dispatch({
    type: SET_PACKAGE_FILTER,
    payload: payload
  })
export const setManagePackageFilter = payload => dispatch =>
  dispatch({
    type: SET_MANAGE_PACKAGE_FILTER,
    payload: payload
  })
export const setStatusFilter = payload => dispatch =>
  dispatch({
    type: SET_STATUS_FILTER,
    payload: payload
  })
export const setCompanySearch = payload => dispatch =>
  dispatch({
    type: SET_COMPANY_SEARCH,
    payload: payload
  })
export const setUserType = payload => dispatch =>
  dispatch({
    type: SET_USER_TYPE_FILTER,
    payload: payload
  })
export const searchManageQuery = payload => dispatch =>
  dispatch({
    type: SET_MANAGE_SEARCH,
    payload: payload
  })
export const setManageBrandsFilter = payload => dispatch =>
  dispatch({
    type: SET_MANAGE_BRANDS_SEARCH,
    payload: payload
  })
export const setManageEndDate = payload => dispatch =>
  dispatch({
    type: SET_MANAGE_END_DATE,
    payload: payload
  })
export const setManageStartDate = payload => dispatch =>
  dispatch({
    type: SET_MANAGE_START_DATE,
    payload: payload
  })

// active video actions
export const setActiveVideoPlatform = payload => dispatch =>
  dispatch({
    type: SET_ACTIVE_VIDEO_PLATFORM,
    payload: payload
  })
export const setActiveVideoPackage = payload => dispatch =>
  dispatch({
    type: SET_ACTIVE_VIDEO_PACKAGE,
    payload: payload
  })
export const setActiveVideoSearch = payload => dispatch =>
  dispatch({
    type: SET_ACTIVE_VIDEO_SEARCH,
    payload: payload
  })
export const setActiveVideoType = payload => dispatch =>
  dispatch({
    type: SET_ACTIVE_VIDEO_TYPE,
    payload: payload
  })
export const setActiveVideoStartDate = payload => dispatch =>
  dispatch({
    type: SET_ACTIVE_VIDEO_START_DATE,
    payload: payload
  })
export const setActiveVideoEndDate = payload => dispatch =>
  dispatch({
    type: SET_ACTIVE_VIDEO_END_DATE,
    payload: payload
  })
